import { useEffect, useState } from 'react';
import {
  FormRiderModel,
  deleteFormRiderRegister,
  getFormRiderRegisterData,
} from '../../../models/formRider';
import { DEFAULT_ROWS_PER_PAGE } from '../../../config-global';
import { ConfirmEnum } from '../../../enums/confirmEnum';
import { useTranslation } from 'react-i18next';
import { convertDateStringToNormalString } from '../../../utils/convertDateFormat';

const useFormDriverRegisterController = () => {
  const [dataFormRider, setDataFormRider] = useState<FormRiderModel[]>([]);
  const [selectedFormRiderId, setSelectedFormRiderId] = useState<string>(null!);
  const [searchValue, setSearchValue] = useState<string>('');
  const [currentFormPage, setCurrentFormPage] = useState<number>(1);
  const [openFormRiderRegister, setOpenFormRiderRegister] = useState<boolean>(false);
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [loadingDeleteButton, setLoadingDeleteButton] = useState<boolean>(false);
  const [openDeleteForm, setOpenDeleteForm] = useState<boolean>(false);
  const [openMenu, setOpenMenu] = useState(null);
  const [tabFormRider, setTabFormRider] = useState<ConfirmEnum>(ConfirmEnum.NOT_CONFIRM);

  const { t } = useTranslation('global');

  const TableHeaderValue: string[] = [
    t('registerFormRider_page.No'),
    t('registerFormRider_page.First name'),
    t('registerFormRider_page.Last name'),
    t('registerFormRider_page.Phone number'),
    t('registerFormRider_page.Gender'),
    t('registerFormRider_page.Date of Birth'),
    t('registerFormRider_page.address'),
    t('registerFormRider_page.Register Date'),
    t('Status'),
    '',
  ];

  const handleOpenFormRiderRegister = () => {
    setOpenFormRiderRegister(true);
  };

  const handleCloseFormRiderRegister = () => {
    setOpenFormRiderRegister(false);
    setOpenMenu(null);
  };

  const handleOpenMenuFormRider = (event: any, getId: string) => {
    setOpenMenu(event.currentTarget);
    setSelectedFormRiderId(getId);
  };

  const handleCloseMenu = () => {
    setOpenMenu(null);
  };

  const handleOpenDeleteForm = () => {
    setOpenDeleteForm(true);
  };

  const handleCloseDeleteForm = () => {
    setOpenDeleteForm(false);
  };

  const handleChangePage = (event: any, newPage: any) => {
    setCurrentFormPage(newPage);
  };

  const handleSearch = (e: any) => {
    setSearchValue(e.target.value);
  };

  const filterFormByStatus: FormRiderModel[] = dataFormRider?.filter((item: FormRiderModel) => {
    if (tabFormRider === ConfirmEnum.CONFIRM) {
      return item?.confirm === true;
    } else if (tabFormRider === ConfirmEnum.NOT_CONFIRM) {
      return item?.confirm === false;
    }
    return false;
  });

  const filterFormRider: FormRiderModel[] = filterFormByStatus
    ?.filter((item: FormRiderModel) =>
      item?.firstName?.toLowerCase()?.includes(searchValue.toLowerCase())
    )
    .sort((a, b) => {
      // convertDateStringToNormalString(b.createdAt).localeCompare(
      //   convertDateStringToNormalString(a.createdAt)
      // );
      const aDate = new Date(a.createdAt);
      const bDate = new Date(b.createdAt);

      // Compare dates
      if (aDate < bDate) return 1;
      if (aDate > bDate) return -1;
      return 0;
    });

  const rowFormRider: FormRiderModel[] = filterFormRider.slice(
    (currentFormPage - 1) * DEFAULT_ROWS_PER_PAGE,
    currentFormPage * DEFAULT_ROWS_PER_PAGE
  );

  const isSearchNotFound: boolean = !rowFormRider.length && !!searchValue;
  const countFormPagination = Math.ceil(filterFormRider.length / DEFAULT_ROWS_PER_PAGE);
  const selectedFormRider = rowFormRider.find((form) => form.id === selectedFormRiderId);

  const handleFetchData = async () => {
    try {
      setLoadingData(true);
      const resData = await getFormRiderRegisterData();
      setDataFormRider(resData);
    } catch (err) {
      console.error('this error', err);
    } finally {
      setLoadingData(false);
    }
  };

  const handleDeleteFormRiderRegister = async () => {
    try {
      setLoadingDeleteButton(true);
      await deleteFormRiderRegister(selectedFormRiderId);
      await handleFetchData();
      setOpenDeleteForm(false);
      setOpenMenu(null);
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again');
      }
    } finally {
      setLoadingDeleteButton(false);
    }
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  return {
    rowFormRider,
    handleDeleteFormRiderRegister,
    isSearchNotFound,
    handleSearch,
    handleChangePage,
    handleCloseDeleteForm,
    handleOpenDeleteForm,
    handleCloseMenu,
    handleOpenMenuFormRider,
    handleCloseFormRiderRegister,
    handleOpenFormRiderRegister,
    openMenu,
    openDeleteForm,
    loadingDeleteButton,
    loadingData,
    openFormRiderRegister,
    currentFormPage,
    searchValue,
    countFormPagination,
    selectedFormRider,
    handleTabFormRider: (newValue: ConfirmEnum) => setTabFormRider(newValue),
    tabFormRider,
    TableHeaderValue,
    handleFetchData,
  };
};
export default useFormDriverRegisterController;
